module.exports = __webpack_public_path__ + "img/8.987df53c.png";